module.exports = __webpack_public_path__ + "assets/img/loading.e1f54a7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/loading.gif
// module id = 248
// module chunks = 45